var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHelp = function SvgIconHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "icon-help_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".icon-help_svg__st0{fill:#666}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512.02 959.81c-119.6 0-232.08-46.57-316.66-131.13-84.58-84.62-131.17-197.07-131.17-316.66 0-119.58 46.59-232.03 131.17-316.62 84.58-84.58 197.06-131.15 316.66-131.15s232.04 46.57 316.62 131.13c84.58 84.61 131.17 197.06 131.17 316.64 0 119.6-46.59 232.04-131.17 316.64-84.58 84.57-197.02 131.15-316.62 131.15m0-852.93c-108.22 0-209.98 42.15-286.52 118.68-76.5 76.52-118.64 178.26-118.64 286.46 0 108.22 42.13 209.96 118.64 286.5 76.54 76.5 178.3 118.66 286.52 118.66 108.18 0 209.94-42.15 286.48-118.68 76.5-76.52 118.64-178.26 118.64-286.48 0-108.2-42.13-209.94-118.64-286.48-76.54-76.51-178.3-118.66-286.48-118.66",
    className: "icon-help_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512.02 631.96c-11.76 0-21.34-9.53-21.34-21.32v-85.29c0-11.78 9.57-21.32 21.34-21.32 58.78 0 106.6-47.84 106.6-106.62s-47.82-106.62-106.6-106.62-106.6 47.84-106.6 106.62c0 11.78-9.57 21.32-21.34 21.32s-21.34-9.53-21.34-21.32c0-82.31 66.97-149.26 149.28-149.26S661.3 315.11 661.3 397.42c0 75.06-55.7 137.36-127.94 147.74v65.49c0 11.78-9.58 21.31-21.34 21.31",
    className: "icon-help_svg__st0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M512.01 802.55c29.44 0 53.31-23.87 53.31-53.31s-23.87-53.31-53.31-53.31-53.31 23.87-53.31 53.31 23.86 53.31 53.31 53.31",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#666"
    }
  }));
};
export default SvgIconHelp;